import { render, staticRenderFns } from "./solicitud-evaluacion-hogar-resumen.vue?vue&type=template&id=65d115aa&"
import script from "./solicitud-evaluacion-hogar-resumen.vue?vue&type=script&lang=ts&"
export * from "./solicitud-evaluacion-hogar-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports